import { Environment } from "./environment.model";
import {
  AI_URL_DEVELOP,
  BACKEND_DEVELOP,
  BACKENDV5_DEVELOP,
  FIREBASE_DEVELOP,
  FROALA_KEY,
  LANGUAGES_DEVELOP,
  PAY_URL_DEVELOP,
  RC,
  VERSION,
  XLS_DEVELOP,
  XLS_TEMPLATES_DEVELOP,
} from "./global";

export const ENV: Environment = {
  backend: BACKEND_DEVELOP,
  backendV5: BACKENDV5_DEVELOP,
  fileServerXlsxToJson: XLS_DEVELOP,
  firebase: FIREBASE_DEVELOP,
  froalaKey: FROALA_KEY,
  globalConfig: {
    _setTimeout: 200,
  },
  globalLanguages: LANGUAGES_DEVELOP,
  ia_api_url: AI_URL_DEVELOP,
  mode: "Development",
  pay_api_url: PAY_URL_DEVELOP,
  version: `${VERSION}${RC ? "-rc." + RC : ""}`,
  xls_templates: XLS_TEMPLATES_DEVELOP,
};



// WEBPACK FOOTER //
// ./src/environments/environment.dev.ts